import {mergeMap} from 'rxjs/operators';
import {Component, ViewChild, Input, Inject} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

import {AppService} from '../../commons/app.service';
import {FourDService, ProcessorAPI, Account} from '4d-mapper';
import {MatSnackBar, MatDialog, MatTreeNestedDataSource, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {QMAP} from 'ng-qmap';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';
import {TranslateService} from '@ngx-translate/core';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import {AppRoutes} from '../../commons/global';
import { AclService } from '@src/app/commons/acl/acl.service';


// generic helpers
import {Constants} from './../../commons/Constants';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';
import { LinkURLDirective } from 'vasat-ng';

@Component({
  selector: 'settings-comp',
  templateUrl: './settings.component.html'

})
export class SettingsComponent extends AppBaseComponent {
  @ViewChild(LinkURLDirective,{static:false}) imageDirective
  
  error: string
  success: string

  constructor(public fourD: FourDService, 
              public service: AppService, 
              public router: Router,
              public snackBar: MatSnackBar, 
              public dialog: MatDialog, 
              private activeRoute: ActivatedRoute,
              public translate: TranslateService, 
              public uiManager: UiManagerService,
              public permissions: AclService,
              applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents)
    /*
       this.sub = this.fourD.aa().subscribe(s =>
           this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.aa.id)
    )
    */
  }

  onReady() {

    // hack for old qMap upload
    this.fourD.activeTeam['V'] = this.fourD.activeTeam.vasat
    // hide HangOn / waiting box (if open)
    Constants.hideHangOn();
    /*
    this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.aa.id)
    this.fourD.aa.accountGroups.queryObservable().subscribe(res => this.groups = res.items)
    */
  }

  saveCurrentAccount() {
    var okMsg
    var errMsg
    this.translate.get(['SETTINGS.ACC_SAVE_OK', 'SETTINGS.ACC_SAVE_ERR']).pipe(mergeMap(params => {
      okMsg = params['SETTINGS.ACC_SAVE_OK']
      errMsg = params['SETTINGS.ACC_SAVE_ERR']
      return this.fourD.activeTeam.saveObservable()
    })).subscribe(res => {
      this.openSnackBarSuccess(okMsg)
    }, err => {
      this.openSnackBarSuccess(errMsg)
    })
  }



  // delete the account
  /*deleteCurrentAccount() {
    this.openDialogWithMeta({deletename: this.fourD.account.name + ' Account'} , 'GENERIC.DIALOG.DELETE.TITLE', 'GENERIC.DIALOG.DELETE.MSG', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
      if (s) {
        this.fourD.account.destroyObservable().subscribe(_ => {
          this.service.V.logoutObservable().subscribe(
            succ => {
              this.fourD.clearStates()
              // Go to root page on logout
              this.router.navigateByUrl(AppRoutes.AUTH)
            },
            err => {
              this.openSnackBarError(err);
            }
          )
        }, error1 => {
          this.openSnackBarError('Error while deleting the account, please ensure you delete your projects and data.');
        });
      }
    });
  }*/

  uploadFile(event) {
    this.loading = true
    let fileList: FileList = event.target.files
    if(fileList.length > 0) {
        let file: File = fileList[0]
        fetch(this.fourD.V.config.host + "/api/Account/" + this.fourD.activeTeam.id + '/image.png',{
            method: 'POST',
            body: file,
            headers:{
                'Content-type':'application/binary',
                Authorization:'bearer ' + this.service.V.authToken()
            }
          }
        ).then(r => { 
            this.loading = false
            // Reload the img src after file uplaoded to server
            this.imageDirective.updateLink()
        })
       
    }
    else{
        this.loading = false
    }
}


}
